import { axios, base } from '../http';

export const badgeOrderGetGlobalConfig = () =>
    axios.get(`${base}/api/BadgeOrderAdmin/GetGlobalConfig`);

/** 获取支付宝应用配置下拉选项 */

export const badgeOrderGetAliPayConfigOptions = () =>
    axios.get(`${base}/api/BadgeOrderAdmin/GetAliPayConfigOptions`);

/** 保存全局配置 */

export const badgeOrderSaveGlobalConfig = (data) =>
    axios.put(`${base}/api/BadgeOrderAdmin/SaveGlobalConfig`, data);

/** 获取家长办理收集字段列表 */

export const badgeOrderGetCollectFields = () =>
    axios.get(`${base}/api/BadgeOrderAdmin/GetCollectFields`);

/** 新增/编辑收集字段 */

export const badgeOrderSaveCollectField = (data) =>
    axios.post(`${base}/api/BadgeOrderAdmin/SaveCollectField`, data);

/** 删除收集字段 */

export const badgeOrderDeleteCollectField = (id) =>
    axios.delete(`${base}/api/BadgeOrderAdmin/DeleteCollectField`, { params: { id } });

/** 一键添加常用收集字段（姓名、班级、联系方式等） */

export const badgeOrderInitDefaultCollectFields = () =>
    axios.post(`${base}/api/BadgeOrderAdmin/InitDefaultCollectFields`);

/** 获取校徽样式模板列表 */

export const badgeOrderGetStyleTemplates = () =>
    axios.get(`${base}/api/BadgeOrderAdmin/GetStyleTemplates`);

/** 新增/编辑样式模板（底图、画布尺寸、图层 JSON） */

export const badgeOrderSaveStyleTemplate = (data) =>
    axios.post(`${base}/api/BadgeOrderAdmin/SaveStyleTemplate`, data);

/** 删除样式模板 */

export const badgeOrderDeleteStyleTemplate = (id) =>
    axios.delete(`${base}/api/BadgeOrderAdmin/DeleteStyleTemplate`, { params: { id } });

/** 设为默认样式模板 */

export const badgeOrderSetDefaultStyleTemplate = (id) =>
    axios.put(`${base}/api/BadgeOrderAdmin/SetDefaultStyleTemplate`, null, { params: { id } });

/** 获取校徽套餐列表 */

export const badgeOrderGetPackages = () =>
    axios.get(`${base}/api/BadgeOrderAdmin/GetPackages`);

/** 新增/编辑套餐 */

export const badgeOrderSavePackage = (data) =>
    axios.post(`${base}/api/BadgeOrderAdmin/SavePackage`, data);

/** 删除套餐 */

export const badgeOrderDeletePackage = (id) =>
    axios.delete(`${base}/api/BadgeOrderAdmin/DeletePackage`, { params: { id } });

/** 调整套餐排序（moveUp：true 上移，false 下移） */

export const badgeOrderMovePackage = (id, moveUp) =>
    axios.put(`${base}/api/BadgeOrderAdmin/MovePackage`, null, { params: { id, moveUp } });

/** 订购记录分页查询（keyword、payStatus、orderStatus、page、pageSize） */

export const badgeOrderGetOrders = (params) =>
    axios.get(`${base}/api/BadgeOrderAdmin/GetOrders`, { params });

/** 订购记录详情 */

export const badgeOrderGetOrderDetail = (orderId) =>
    axios.get(`${base}/api/BadgeOrderAdmin/GetOrderDetail`, { params: { orderId } });

/** 支付宝退款 */

export const badgeOrderRefund = (data) =>
    axios.post(`${base}/api/BadgeOrderAdmin/Refund`, data);

/** 更新订单业务状态（待生产/生产中/已完成等） */

export const badgeOrderUpdateOrderStatus = (data) =>
    axios.put(`${base}/api/BadgeOrderAdmin/UpdateOrderStatus`, data);

/** 批量清理超时待支付订单（orderIds 为空则清理全部超时单，minutes 默认 30） */

export const badgeOrderBatchCleanupPendingOrders = (data) =>
    axios.post(`${base}/api/BadgeOrderAdmin/BatchCleanupPendingOrders`, data);

/** 订购统计（学校/年级/班级归并） */

export const badgeOrderGetOrderStatistics = (params) =>
    axios.get(`${base}/api/BadgeOrderAdmin/GetOrderStatistics`, { params });

/** 导出订购统计 Excel（汇总 + 班级统计 + 订单明细） */

export const badgeOrderExportOrderStatisticsExcel = (params) =>
    axios.get(`${base}/api/BadgeOrderAdmin/ExportOrderStatisticsExcel`, { params, responseType: 'blob', skipGlobalHttpErrorToast: true });

/** 导出厂家制作单 ZIP（Excel + 证件照） */

export const badgeOrderExportOrdersExcel = (params) =>
    axios.get(`${base}/api/BadgeOrderAdmin/ExportOrdersExcel`, { params, responseType: 'blob', skipGlobalHttpErrorToast: true });

/** 导出订购记录 Excel（管理端列表筛选，仅明细，不分页） */

export const badgeOrderExportOrdersListExcel = (params) =>
    axios.get(`${base}/api/BadgeOrderAdmin/ExportOrdersListExcel`, { params, responseType: 'blob', skipGlobalHttpErrorToast: true });

// ========== 奥讯达基础信息同步 ==========

/** 获取学校奥讯达配置 */
